import { createAction } from '@reduxjs/toolkit';

import { useActionObservableCallback } from '@perpay-web/hooks/useActionObservableCallback';
import { useSteps } from '@perpay-web/hooks/useSteps';
import { hookAction$ } from '@perpay-web/services/singletons';
import { createContextProvider } from '@perpay-web/utils/componentUtils';

export const ADD_TO_WALLET_STEP = 'add-to-wallet';
export const SUCCESS_STEP = 'success';

const steps = [ADD_TO_WALLET_STEP, SUCCESS_STEP];

export const virtualProvisioningStepsSetStep = createAction(
    'VIRTUAL_PROVISIONING_STEPS::SET_STEP',
);

const providerFactory = (Context) => {
    const Provider = ({ children }) => {
        const hook = useSteps(steps);

        useActionObservableCallback(
            hookAction$,
            virtualProvisioningStepsSetStep().type,
            (step) => hook.setStep(step),
        );

        return <Context.Provider value={hook}>{children}</Context.Provider>;
    };

    return Provider;
};

export const [
    VirtualProvisioningModalStepsProvider,
    useVirtualProvisioningModalStepsContext,
] = createContextProvider(providerFactory);
